import type { CaregiverRelationshipKind } from '../../../__generated__/globalTypes';
import type { IDependantDateOfBirth } from '../../../lib/dependants/helpers';

export type { IDependantDateOfBirth };

export interface IDependantFormValues {
  relationship: CaregiverRelationshipKind | null;
  isStep: boolean;
  isInLaw: boolean;
  firstName: string;
  lastName: string;
  preferredName: string;
  dateOfBirth: IDependantDateOfBirth | null;
}

export const createEmptyDependantFormValues = (): IDependantFormValues => ({
  relationship: null,
  isStep: false,
  isInLaw: false,
  firstName: '',
  lastName: '',
  preferredName: '',
  dateOfBirth: null,
});
